<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 08:59:09
 * @Description: 甘特图右侧下方图形区主体组件
-->

<template>
  <div
    class="gantt-content"
    :class="{
      'gantt-content-printModel': $store.state.viewSchem.isPrintModeShow
    }"
    @scroll.passive="scrollEvent($event)"
    @contextmenu.prevent="ContextmenuHandleOut"
  >
    <template
      v-if="rowsShow.length > 0"
    >
      <!-- 选中行 -->
      <template v-if="completeShow">
        <div class="selected-rows">
          <template v-for="selectId in selectedArr">
            <SelectRow
              :key="ganttType  + '-' + selectId"
              :rowId="selectId"
              :estimatedItemSize="estimatedItemSize"
              :rowsShowMap="rowsShowMap"
            ></SelectRow>
          </template>
        </div>
      </template>

      <!-- 甘特图背景网格线 -->
      <ContentBg
        :rowsShow="rowsShow"
        :cols="$store.getters.durationTimeArr"
        :rowsShowMap="rowsShowMap"
        :totalHeight="totalHeight"
        :gridXBgConfig="$store.getters.gridXBgConfig"
        :gridYBgConfig="$store.getters.gridYBgConfig"
        :isDragging="$store.state.isDragging"
        :estimatedItemSize="estimatedItemSize"
        @ResetDashLines="ResetDashLines"
      />

      <!-- 垂直线 -->
      <template v-for="(yAxisItem) in yAxisArr">
        <YAxis
          :data-key="yAxisItem.key"
          :key="yAxisItem.key"
          v-bind="yAxisItem"
        />
      </template>

      <!-- 关系连线 -->
      <template v-if="$store.state.viewSchem.isLineShow === true && completeShow">
        <GtLinesPlus
          v-if="$store.state.viewSchem.isLineShowType===2"
          :barsCSSInfo="barsCSSInfo"
          :totalHeight="totalHeight"
        >
        </GtLinesPlus>
        <GtLines
          v-else
          :barsCSSInfo="barsCSSInfo"
          :totalHeight="totalHeight"
        ></GtLines>
      </template>

      <!-- 连线指示虚线 -->
      <template v-if="completeShow">
        <GuideLine v-show="ganttType === $store.state.ganttType" />
      </template>

      <!-- 横道 -->
      <div class="gantt-bars">
        <!-- 虚线横道 -->
        <div
          v-show="dashedBarInfo.show"
          class="dashed-task"
          :style="dashedBarInfo.css"
        ></div>
        <!-- 空白横道 -->
        <template v-for="(empty) in emptyBarsCSSInfo">
          <EmptyBar
            :key="empty.taskId"
            :emptyBarInfo="empty"
          ></EmptyBar>
        </template>
        <!-- 常规横道 -->
        <template v-for="(task, taskIndex) in barsCSSInfo">
          <div
            v-if="task._width > 0"
            class="task"
            :key="ganttType  + '-' + task._id"
            :title="task.title"
            :style="{
              'top': task._top + 'px',
              'left': task._left + 'px',
              'width': task._width + 'px',
              'height': task.crossHeightVal + 'px',
              'z-index': task.crossObjName == 'task'? Number(task.crossLevel + task.curRow) + 510: 800,
            }"
            @click.stop
            @contextmenu.prevent.stop="ContextmenuHandle($event, task)"
            :data-id="task._id"
            :data-index="taskIndex"
          >
            <!-- 形状分类 -->
            <div
              class="task-wrap"
              v-show="!task.isHide"
              @click="handlerClickBar(task)"
              @dblclick="handlerDBClickBar(task)"
            >
              <!-- 里程碑 -->
              <div
                v-if="task.crossObjName == 'landmarks'"
                class="type-box type-landmarks"
                :class="{
                  'task-searched': searchedList.includes(task.taskId),
                  'task-wrap-border': isTaskBorderShow,
                }"
                :draggable="getAuthentication && task.draggable"
                @dragstart="Dragstart(task, $event)"
                @dragend="DragEnd($event)"
              >
                <div
                  class="type-landmarks-content"
                  :style="{
                    'background': task.barColor,
                    'box-shadow': (task.highlightType === $store.state[ganttType + '_highlightType']? highlightColor: ''),
                  }"></div>
                <!-- 行内·展示文案二 -->
                <div
                    class="task-info-inner"
                    :title="task.title"
                    v-if="task.labelIsShow && task.innerDesc && task.innerDesc != ''"
                    v-show="!isAdjust && !$store.state.isDragging"
                    :style="{
                      left: (typeof task._midTimeOffSet == 'number'? task._midTimeOffSet: 0) + 'px',
                      ...barsWordStyle
                    }"
                >
                  <span></span>
                  <span class="task-info-txt">{{task.innerDesc}}</span>
                </div>

              </div>
              <!-- 统计 -->
              <div
                v-else-if="task.crossObjName == 'group'"
                class="type-box type-group"
                :class="{
                  'task-searched': searchedList.includes(task.taskId)
                }"
                :draggable="getAuthentication && task.draggable"
                @dragstart="Dragstart(task, $event)"
                @dragend="DragEnd($event)"
              >
                <div
                  class="type-group-left"
                  :style="{
                    'border-left-color': task.barColor,
                    'border-top-color': task.barColor,
                  }"></div>
                <div
                  class="type-group-mid"
                  :style="{
                    'background-color': task.barColor,
                    'box-shadow': (task.highlightType === $store.state[ganttType + '_highlightType']? highlightColor: ''),
                  }"></div>
                <div
                  class="type-group-right"
                  :style="{
                    'border-right-color': task.barColor,
                    'border-top-color': task.barColor,
                  }"></div>
              </div>
              <!-- 普通 -->
              <div
                v-else
                class="type-box type-task-default"
                :class="{
                  'task-no-radius': noTaskBorderRadiusShow,
                  'task-wrap-border': isTaskBorderShow,
                  'task-searched': searchedList.includes(task.taskId),
                }"
                :draggable="getAuthentication && task.draggable"
                @dragstart="Dragstart(task, $event)"
                @dragover="DragMove($event)"
                @dragend="DragEnd($event)"
                :style="{
                  'background': task.barColor,
                  'box-shadow': (task.highlightType === $store.state[ganttType + '_highlightType']? highlightColor: ''),
                }"
              >
                <!-- 行内·展示文案二 -->
                <div
                    class="task-info-inner"
                    :title="task.title"
                    v-if="task.labelIsShow && task.innerDesc && task.innerDesc != ''"
                    v-show="!isAdjust && !$store.state.isDragging"
                    :style="{
                      left: (typeof task._midTimeOffSet == 'number'? task._midTimeOffSet: 0) + 'px',
                      ...barsWordStyle
                    }"
                >
                  <span></span>
                  <span class="task-info-txt">{{task.innerDesc}}</span>
                </div>
                <!-- 调节起止工具栏: 时间提示信息·调节左右工具条 -->
                <template
                  v-if="task.adjustable && (task._width >= minAdjustableWidth)"
                >
                  <div
                    v-show="adjustType !== 'default' && task.taskListIndex == adjustInfo.taskListIndex"
                    :class="{
                      'adjust-info': true,
                      'adjust-info-first': adjustInfo._parentIndex == 0 && adjustInfo.curRow == 1,
                      'adjust-info-left': adjustType === 'startDate',
                      'adjust-info-right': adjustType === 'endDate',
                    }"
                  >
                    {{ $dayjs(adjustInfo[adjustType]).format("YYYY/MM/DD HH:mm:ss") }} <span class="adjust-info-percent" v-if="task.showPercent === true">
                      {{"  " + adjustInfo._percentShow }}
                    </span>
                  </div>
                  <div
                    v-show="task.leftDrag === true"
                    class="task-adjust task-adjust-left"
                    draggable="false"
                    @click.stop.prevent
                    @mousedown.stop="ChangeSFTime($event, task, 'startDate')"
                  >
                    <div class="task-adjust-line"></div>
                  </div>
                  <div
                    class="task-adjust task-adjust-right"
                    draggable="false"
                    @click.stop.prevent
                    @mousedown.stop="ChangeSFTime($event, task, 'endDate')"
                  >
                    <div class="task-adjust-line"></div>
                  </div>
                </template>
                <!-- 拖拽识别容器 -->
                <div
                  v-if="$store.getters.dropTargetType === 2"
                  class="drop-target-2"
                  @dragenter.prevent
                  @dragover.prevent
                  @dragleave.prevent
                  @drop.prevent="DropHandle($event, task)"
                >
                </div>
              </div>
            </div>

            <!-- 上侧·展示文案一  -->
            <template v-if="task.labelIsShow && task.desc && task.desc != ''">
              <div
                v-show="!isAdjust && !$store.state.isDragging"
                class="task-info task-info-side-top"
                :style="{
                  'top': ($store.state.viewSchem.isPrintModeShow? ((-1 * ($store.state.viewSchem.barsFontSize  + 4)) - (task.crossHeightVal < $store.state.viewSchem.barsFontSize? ($store.state.viewSchem.barsFontSize + 4) - task.crossHeightVal: 0)+ 'px'): '-15px'),
                  'left': (typeof task._topTimeOffSet == 'number'? task._topTimeOffSet: 0) + 'px',
                  ...barsWordStyle
                }"
                @contextmenu.prevent.stop
                @click.stop="handlerClickBar(task)"
              >
                <!-- 文字前置图标 -->
                <template v-if="task.descIconList instanceof Array">
                  <template v-for="descIconItem in task.descIconList">
                    <!-- 苍穹图标 -->
                    <i
                      v-if="descIconItem.type === 'platform' "
                      :key="'cq-' + descIconItem.val"
                      class="task-info-icon"
                      :data-type="descIconItem.type"
                      :style="{'color': $store.state.theme, ...iconStyle}"
                      :class="descIconItem.val"
                    ></i>
                    <!-- 本地图标 -->
                    <i
                      v-else-if="descIconItem.type === 'local' && iconList[descIconItem.val] "
                      :key="'local-' + descIconItem.val"
                      class="task-info-icon"
                      :data-type="descIconItem.type"
                      :style="{'color': $store.state.theme, ...iconStyle}"
                      :class="iconList[descIconItem.val]"
                    ></i>
                    <!-- 网络图片 -->
                    <img
                      v-else-if="descIconItem.type === 'img'"
                      :key="'img-' + descIconItem.val"
                      :data-type="descIconItem.type"
                      class="task-info-img"
                      :src="descIconItem.val"
                      :style="imgStyle"
                    />
                    <!-- 背景图片 -->
                    <i
                      v-else-if="descIconItem.type === 'url'"
                      :key="'bg-' + descIconItem.val"
                      :data-type="descIconItem.type"
                      class="task-info-img"
                      :style="{'background-image': 'url(' + descIconItem.val + ')', ...imgStyle}"
                    ></i>
                  </template>
                </template>
                <span></span>
                <span
                  class="task-info-txt"
                >{{task.desc}}</span>
              </div>
            </template>

            <!-- 下侧·展示文案五  -->
            <template v-if="task.labelIsShow && task.botDesc && task.botDesc != ''">
              <div
                v-show="!isAdjust && !$store.state.isDragging"
                class="task-info task-info-side-bot"
                :style="{
                  'top': 'initial',
                  'bottom':($store.state.viewSchem.isPrintModeShow?(`-${$store.state.viewSchem.barsFontSize + 4}px`): '-15px'),
                  'left': (typeof task._bottomTimeOffSet == 'number'? task._bottomTimeOffSet: 0) + 'px',
                  ...barsWordStyle
                }"
                @contextmenu.prevent.stop
                @click.stop="handlerClickBar(task)"
              >
                <span></span>
                <span
                  class="task-info-txt"
                >{{task.botDesc}}</span>
              </div>
            </template>

            <!-- 左侧·展示文案三  -->
            <template v-if="task.labelIsShow && task.leftDesc && task.leftDesc != ''">
              <div
                v-show="!isAdjust && !$store.state.isDragging"
                class="task-info-side task-info-side-left"
                :style="{
                  'right': (task._width + 4 + (typeof task._leftTimeOffSet == 'number'? task._leftTimeOffSet: 0)) + 'px',
                  ...barsWordStyle
                }"
                @contextmenu.prevent.stop
                @click.stop="handlerClickBar(task)"
              >
                <span></span>
                <span class="task-info-side-txt">{{task.leftDesc}}</span>
              </div>
            </template>

            <!-- 右侧·展示文案四  -->
            <template v-if="task.labelIsShow && task.rightDesc && task.rightDesc != ''">
              <div
                v-show="!isAdjust && !$store.state.isDragging"
                class="task-info-side task-info-side-right"
                :style="{
                  'left': (task._width + 4 + (typeof task._rightTimeOffSet == 'number'? task._rightTimeOffSet: 0)) + 'px',
                  ...barsWordStyle
                }"
                @contextmenu.prevent.stop
                @click.stop="handlerClickBar(task)"
              >
                <span></span>
                <span class="task-info-side-txt">{{task.rightDesc}}</span>
              </div>
            </template>

            <!-- 左连接pre -->
            <div
              class="task-link-wrap task-link-wrap-left"
              @click.stop="False(task._parentIndex)"
              v-show="
                completeShow &&
                $store.state.ganttType === ganttType &&
                $store.state.selectTaskIndex != -1 &&
                task.isLine === true &&
                dashStartTask.isLine === true
              "
            >
              <!-- 连接点:有效选中合规连线横道、按住移动时其他待连接合规横道展示 -->
              <div
                class="task-link link-left"
                @mousedown.left="LinkDash($event, 'pre', task)"
                v-show="dashStartIndex == task.taskListIndex || moveLinkFlag"
                :style="{
                  'border-color': 'blue',
                }"
              ></div>
            </div>
            <!-- 右连接next -->
            <div
              class="task-link-wrap task-link-wrap-right"
              @click.stop="False(task._parentIndex)"
              v-show="
                completeShow &&
                $store.state.ganttType === ganttType &&
                $store.state.selectTaskIndex != -1 &&
                task.isLine === true &&
                dashStartTask.isLine === true
              "
            >
              <!-- 连接点 -->
              <div
                class="task-link link-right"
                @mousedown.left="LinkDash($event, 'next', task)"
                v-show="dashStartIndex == task.taskListIndex || moveLinkFlag"
                :style="{
                  'border-color': 'blue',
                }"
              ></div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <div
      v-else
      class="empty-box"
    ></div>

  </div>
</template>

<script>
function getItemInfo(item, rowIndex, selfIndex, rowsShowMap = null, _self) {
  if (
    typeof _self != "object" ||
    typeof item != "object"
  ) return {};
  const _baseWidth = _self.$store.getters.cellWidth;
  const _type = _self.$store.state.cellUnitType;
  var result;
  var _top;
  let _width;
  let _left;
  // 文案偏移
  const _topTimeOffSet = _self.$utils.getDiffWidth(_type, 0, item.topTimeOffSet, _baseWidth, false);
  const _bottomTimeOffSet = _self.$utils.getDiffWidth(_type, 0, item.bottomTimeOffSet, _baseWidth, false);
  const _leftTimeOffSet = _self.$utils.getDiffWidth(_type, 0, item.leftTimeOffSet, _baseWidth, false) * (-1);
  const _rightTimeOffSet = _self.$utils.getDiffWidth(_type, 0, item.rightTimeOffSet, _baseWidth, false);
  const _midTimeOffSet = _self.$utils.getDiffWidth(_type, 0, item.midTimeOffSet, _baseWidth, false);

  // 内部任务信息
  const _id = item.taskId;
  const _parentIndex = rowIndex; // 横道所在行的下标
  const _selfIndex = selfIndex; // 当前渲染横道数组中自己下标

  // 距顶
  const _rowHeight = _self.$store.state.cellHeight;
  const _taskHeight = _self.$store.state.taskHeight;
  const _totalTopRowNum = rowsShowMap ? (rowsShowMap[item.groupId].startRow - 1 + item.curRow - 1) : rowIndex;
  const _diffY = (item.crossObjName === "task" && item.crossHeightVal > 0) ? (_taskHeight - item.crossHeightVal) : 0;
  _top = ((_rowHeight - _taskHeight) / 2) + _totalTopRowNum * _rowHeight + _diffY;

  try {
    if (
      !(typeof item.startDate == "number") ||
          item.startDate < 0 ||
          !(typeof item.endDate == "number") ||
          item.endDate < 0 ||
          item.startDate > item.endDate
    ) {
      throw new Error(`任务${selfIndex}日期非法`);
    }
    // 左定位
    _left = _self.$utils.getDiffWidth(_type, _self.$store.getters.totalStartAndEnd.start, item.startDate, _baseWidth);
    // 里程碑宽度
    if (item.crossObjName === "landmarks") {
      throw new Error("里程碑");
    } else if (item.startDate == item.endDate) {
      throw new Error(`任务${selfIndex}日期非法`);
    }
    // 常规横道宽度
    _width = _self.$utils.getDiffWidth(_type, item.startDate, item.endDate, _baseWidth);

  } catch (error) {
    if (error.toString() === new Error("里程碑").toString()) {
      _width = _taskHeight;
      const _diffLCB = -10;
      _left = _left + _diffLCB;
    } else {
      console.warn("横道-异常:", item);
      _width = 0;
      _left = 0;
    }
  }
  result = {
    ...item, // 源数据
    _top,
    _left,
    _width,

    _id, // -> taskId
    _parentIndex, // groupId -> 所在行下标
    _selfIndex, // -> 自身在横道源数组中下标

    _topTimeOffSet,
    _bottomTimeOffSet,
    _leftTimeOffSet,
    _rightTimeOffSet,
    _midTimeOffSet,

  };
  return result;
}
import CONSTNAME from "@/ConstName.js";
import GtLines from "./GtLines/GtLines";
import GtLinesPlus from "./GtLines/GtLinesPlus";
import GuideLine from "./GuideLine/GuideLine";
import ContentBg from "./ContentBg/ContentBg";
import YAxis from "./YAxis/YAxis";
import SelectRow from "./SelectRow/SelectRow";
import EmptyBar from "./EmptyBar/EmptyBar";
export default {
  name: "Content",
  data() {
    return {
      dashStartType: "next",
      dashStartIndex: -1,
      dashStartTask: {},
      moveLinkFlag: false, // 连线按下虚线指示标记
      // 调节起止点信息
      isAdjust: false,
      adjustType: "default",
      adjustInfo: {},
      minAdjustableWidth: 10, // 最小限制可调整宽度

      time: null, // 双击计时器

      iconList: CONSTNAME.ICON_LIST, // 本地图标集合

    };
  },
  inject: ["CONSTNAME"],
  props: {
    emptyBars: {
      type: Array,
      default: () => { return []; },
    },
    barsArr: {
      type: Array,
      default: () => { return []; },
    },
    rowsShow: {
      type: Array,
      default: () => { return []; },
    },
    yLines: {
      type: Array,
      default: () => { return []; },
    },
    rowsShowMap: {
      type: Object,
      default: () => { return null; },
    },
    // 滚动联动对象
    reactVueComponent: {
      type: Object,
      default: null,
    },
    reactVueIndex: {
      type: Number,
      default: 0,
    },
    ganttType: {
      type: String,
      default: "pageData",
    },
    // 预估行高度
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
  },
  components: {
    GtLines,
    GtLinesPlus,
    GuideLine,
    ContentBg,
    YAxis,
    SelectRow,
    EmptyBar,
  },
  watch: {
    rowsShowMap: {
      handler(newVal, oldVal) {

      },
      deep: true,
      immediate: true,
    },
    barsArr: {
      handler(newVal, oldVal) {

      },
      deep: true,
      immediate: true,
    },
    selectedArr: {
      handler(newVal = [], oldVal) {

      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 完全显示模式·计划区显示 待排区默认忽略无[关系连线， 选中行]
    completeShow() {
      return (this.ganttType !== this.CONSTNAME.TODOS);
    },
    getAuthentication() {
      return this.$utils.getAuthentication(this.$store.state.accessLevel, [1]);
    },
    selectedArr() {
      return this.$store.state[this.ganttType + "_selectedArr"];
    },
    // 列表总高度
    totalHeight() {
      return (this.rowsShowMap ? this.rowsShowMap.totalRow : this.rowsShow.length) * this.estimatedItemSize;
    },
    // 全局竖线
    yAxisArr() {
      const _self = this;
      const _yLinesArr = this.yLines;
      const result = [];
      if (_yLinesArr.length <= 0) return result;
      const _cellUnitType = _self.$store.state.cellUnitType;
      const _totalStart = _self.$store.getters.totalStartAndEnd.start;
      const _baseWidth = _self.$store.getters.cellWidth;

      const _height = _self.totalHeight + "px";
      const _ganttType = _self.ganttType;
      for (const i in _yLinesArr) {
        const _item = _yLinesArr[i];
        const _left = _self.$utils.getDiffWidth(_cellUnitType, _totalStart, _item.time, _baseWidth);
        const _target = {
          isShow: true,
          key: _ganttType + "-" + i + "-" + _left,
          "left": _left + "px",
          "height": _height,
          "color": _item.color,
          "type": _item.type,
          "width": _item.width,
        };
        result.push(_target);
      }
      return result;
    },
    // 空白横道计算
    emptyBarsCSSInfo() {
      const _self = this;
      const _emptys = this.emptyBars;
      if (
        _emptys.length <= 0 ||
        _self.rowsShow.length <= 0
      ) {
        return [];
      }
      const _baseWidth = _self.$store.getters.cellWidth;
      const _type = _self.$store.state.cellUnitType;
      const emptysInfo = [];
      const _rowHeight = _self.$store.state.cellHeight;
      for (let i = 0; i < _emptys.length; i++) {
        const item = _emptys[i];
        const _totalTopRowNum = (_self.rowsShowMap && _self.rowsShowMap[item.groupId]) ? (_self.rowsShowMap[item.groupId].startRow - 1) : i;
        const _top = _totalTopRowNum * _rowHeight + 1;
        const _left = _self.$utils.getDiffWidth(_type, _self.$store.getters.totalStartAndEnd.start, item.startDate, _baseWidth) + 2;
        const _width = _self.$utils.getDiffWidth(_type, item.startDate, item.endDate, _baseWidth) - 3;
        const _height = item.crossHeightVal - 3;
        const _bgColor = item.barColor;
        emptysInfo.push({
          ...item, // 自带属性
          _top,
          _left,
          _width,
          _height,
          _bgColor,
        });
      }
      return emptysInfo;
    },
    // 横道位置信息计算
    barsCSSInfo() {
      const _self = this;
      const tasksArr = _self.barsArr;
      if (
        tasksArr.length <= 0 ||
        _self.rowsShow.length <= 0
      ) {
        return [];
      }
      const result = [];
      const _taskFilter3 = _self.$store.state.viewSchem.taskFilter3 === true;
      const _taskFilter6 = _self.$store.state.viewSchem.taskFilter6 === true;
      for (let i = 0; i < tasksArr.length; i++) {
        const _task = tasksArr[i];
        /* 受控横道 */
        const _isShowType_1 = _task.crossObj == 3 && !(_taskFilter3); // 关键路径横道(3)
        const _isShowType_2 = _task.crossObj == 6 && !(_taskFilter6); // 二级关键路径横道(6)
        if (
          _task.crossObjName === "task" &&
          (
            _isShowType_1 ||
            _isShowType_2
          )
        ) {
          continue;
        }
        /* 常显横道 */
        let _rowIndex = -1;
        try {
          if (this.rowsShowMap == null) {
            _rowIndex = _self.$utils.fnGetIndex(_task.groupId, _self.rowsShow);
          } else {
            _rowIndex = _self.rowsShowMap[_task.groupId].realRow;
          }
        } catch (error) {
          console.warn("捕获", error);
          continue;
        } finally {
          if (_rowIndex > -1) {
            result.push(getItemInfo(_task, _rowIndex, i, _self.rowsShowMap, _self));
          }
        }
      }
      return result;
    },
    // 高亮颜色值
    highlightColor() {
      const shadowColor = "0 0 10px 0 " + this.$store.state.viewSchem.highlightColor;
      return shadowColor;
    },
    // 虚横道
    dashedBarInfo() {
      const dashedBarInfo = this.$store.state[this.ganttType + "_dashedBar"];
      return dashedBarInfo;
    },
    // 搜索结果集合
    searchedList() {
      const _sourceList = this.$store.state.viewSchem.searchedList;
      const _searchedList = [];
      for (const index in _sourceList) {
        _searchedList.push(_sourceList[index].taskId);
      }
      return _searchedList;
    },
    // 常规任务横道是否显示黑色边框
    isTaskBorderShow() {
      return this.$store.state.viewSchem.isTaskBorderShow == true;
    },
    // 常规任务横道是否不显示圆角
    noTaskBorderRadiusShow() {
      return this.$store.state.viewSchem.noTaskBorderRadiusShow == true;
    },
    // 巴条文字样式
    barsWordStyle() {
      return this.$store.getters.barsWordStyle;
    },
    // 巴条图标大小样式
    imgStyle() {
      const fs = this.$store.state.viewSchem.barsFontSize;
      if (
        fs >= 10 &&
        this.$store.state.viewSchem.isPrintModeShow
      ) {
        const fsStr = fs + "px";
        return {
          "width": fsStr,
          "height": fsStr,
        };
      } else {
        return {};
      }
    },
    // 巴条图标大小样式
    iconStyle() {
      const fs = this.$store.state.viewSchem.barsFontSize;
      if (
        fs >= 10 &&
        this.$store.state.viewSchem.isPrintModeShow
      ) {
        const fsStr = fs + "px";
        return {
          "font-size": fsStr,
        };
      } else {
        return {};
      }
    },
  },
  methods: {
    ContextmenuHandleOut() {
      this.ResetDashLines();
    },
    // 鼠标移动位置信息
    getPos(ev) {
      const scrollTop = this.$el.scrollTop || document.body.scrollTop;
      const scrollLeft = this.$el.parentNode.parentNode.parentNode.scrollLeft || document.body.scrollLeft;
      return { x: ev.clientX + scrollLeft, y: ev.clientY + scrollTop, scroll_x: scrollLeft, scroll_y: scrollTop };
    },
    scrollEvent(el) {
      const _self = this;
      const scrollTop = _self.$el.scrollTop;
      const _reactVueComponent = this.reactVueComponent;        
      let targetEl;
      if (
        _reactVueComponent != null &&
          _reactVueComponent.$el != null
      ) {
        targetEl = _reactVueComponent.$el.getElementsByClassName("scroll-list-container")[0];
        targetEl.scrollTop = scrollTop;
      } else {
        targetEl = _self.$el.parentNode.parentNode.parentNode.parentNode.getElementsByClassName(
          "scroll-list-container",
        )[_self.reactVueIndex];
        targetEl.scrollTop = scrollTop;
      }
    },
    False() {
      return false;
    },
    // 选中起点横道【鉴权】
    LockStart(task) {
      const _self = this;
      const index = task.taskListIndex;
      _self.getAuthentication &&
      (() => {
        if (_self.$store.state.moveLinkFlag) {
          // console.log("选中横道重置");
          _self.ResetDashLines();
        } else {
          // console.log("选中横道:", task);
          _self.dashStartIndex = index;
          _self.dashStartTask = task;
          _self.$store.commit("set_ganttType", _self.ganttType);
        }
      })();
    },
    // 记录选中任务块对应的行【鉴权】
    ShowTaskLink(index) {
      const _self = this;
      _self.getAuthentication &&
      (() => {
        // console.log("选中横道所在行", index);
        this.$store.dispatch("selectTaskBg", index);
      })();
    },
    /*
      【鉴权】
      鼠标移动LinkDash赋值指示虚线状态位置【有则设置为终点连线 无则重置虚线起点绑定移动监听轨迹】
      鼠标弹起LinkLineUp发起实际连线判断
    */
    LinkDash(e, type = "next", task) {
      const _self = this;
      _self.getAuthentication &&
      (() => {
        const _uuid = _self.$store.state.uuid;
        if (_self.$store.state.moveLinkFlag) {
          console.log("连线状态: 设置为终点连线");
          _self.LinkLineUp(task, type);
        } else {
          if (task._parentIndex != _self.$store.state.selectTaskIndex) {
            return _self.ShowTaskLink(task._parentIndex);
          }
          _self.moveLinkFlag = true;
          _self.dashStartType = type;
          // 重置虚线起点
          const pyX = _self.$store.state.cellWidth / 4;
          const _crossHeightVal = _self.dashStartTask.crossHeightVal >= 0 ? _self.dashStartTask.crossHeightVal : 20;
          const dashPosTop = task._top + (_crossHeightVal / 2); // 实际横道高与标准的中心差值偏移量 1 -4 4 为圆心位置二次调整偏移量
          const dashPosLeft = type == "pre" ? task._left - pyX - 4 : task._left + task._width + pyX + 4;
          _self.$store.commit("set_dashLine_pos", {
            dashPosTop,
            dashPosLeft,
            ganttType: this.ganttType,
          });
          _self.$store.commit("set_dashLines_css", {
            dashHeight: 0,
            dashDeg: 0,
            moveLinkFlag: true,
          });
          // 算出鼠标相对元素的初始位置
          const pos1 = _self.getPos(e);
          document.getElementById(_uuid).onmousemove = null;
          document.getElementById(_uuid).onmousemove = _self.$utils.throttle((e) => {
            // step1: 判断标记·否则重置
            if (!_self.$store.state.moveLinkFlag) {
              document.getElementById(_uuid).onmousemove = null;
              _self.moveLinkFlag = false;
              return;
            }
            // step2: 计算指示虚线信息
            const pos2 = _self.getPos(e);
            const left = pos2.x - pos1.x;
            const top = pos2.y - pos1.y;
            _self.moveLinkFlag = true;
            const _height = Math.sqrt(Math.pow(left, 2) + Math.pow(top, 2)); // 长度
            let _deg;
            const getDeg = _self.$utils.getDeg;
            if (left > 0) {
              if (top > 0) {
                _deg = -1 * getDeg(left, top);
              } else if (top == 0) {
                _deg = -90;
              } else {
                _deg = -(180 - getDeg(left, top));
              }
            } else if (left == 0) {
              if (top > 0) {
                _deg = 0;
              } else if (top == 0) {
                _deg = 0;
              } else {
                _deg = -180;
              }
            } else {
              if (top > 0) {
                _deg = getDeg(left, top);
              } else if (top == 0) {
                _deg = 90;
              } else {
                _deg = 180 - getDeg(left, top);
              }
            }
            _self.$store.commit("set_dashLines_css", {
              dashHeight: _height,
              dashDeg: _deg,
              moveLinkFlag: true,
            });
          }, 20, true);
        }
      })();
    },
    // 连线【未鉴权】
    LinkLineUp(item, type = "pre") {
      const _self = this;
      const _id = item._id;
      // 判重
      const _index = _self.$store.state.selectTaskIndex;
      const typeProp = _self.dashStartType; // 起点的类型
      if (_self.dashStartTask._id == _id) {
        // 重置
        _self.ResetDashLines();
        return console.log("忽略:点击自身");
      }
      if (!_self.dashStartTask._id || _index == -1) {
        // 重置
        _self.ResetDashLines();
        return console.log("忽略:请先行选中横块");
      }
      if (this.$store.state.dashHeight < 10) {
        // 重置
        _self.ResetDashLines();
        return console.log("忽略:长度太短不可以连接实线");
      }
      const sourceTasks = _self.$store.state[_self.ganttType + "_tasksArr"];

      const _targetArr = sourceTasks[_self.dashStartIndex] ? sourceTasks[_self.dashStartIndex].taskLink : [];
      for (let i = 0; i < _targetArr.length; i++) {
        if (
          _targetArr[i].taskId == _self.dashStartTask._id &&
            _targetArr[i].taskLinkId == _id &&
            _targetArr[i].endLinePosType == type &&
            _targetArr[i].startLinePosType == typeProp
        ) {
          // 重置
          _self.ResetDashLines();
          return console.log("忽略:已存在");
        }
      }
      // 连线
      const linkInfo = {
        "ganttType": _self.ganttType,
        startLinePosType: typeProp,
        endLinePosType: type,
        taskId: _self.dashStartTask._id,
        taskLinkId: _id,
      };
      _self.$store.dispatch("_crossline", {
        "obj": linkInfo,
        "starPosObj": _self.dashStartTask,
        "endPosObj": item,
        "tasksArr": sourceTasks,
        "ganttType": _self.ganttType,
      });
      // 重置虚线状态
      _self.ResetDashLines();
    },
    // 重置虚线状态
    ResetDashLines() {
      const _self = this;
      if (_self.$store.state.moveLinkFlag || _self.dashStartIndex >= 0) {
        const _uuid = _self.$store.state.uuid;
        document.getElementById(_uuid).onmousemove = null;
        _self.dashStartIndex = -1; // 虚线起点重置
        _self.dashStartTask = {};
        _self.moveLinkFlag = false;
        _self.$store.commit("set_dashLines_css", {
          dashHeight: 0,
          dashDeg: 0,
          moveLinkFlag: false,
        });
      }
      this.SetInintlight();
      this.SetInintDashedBar();
    },
    /*
      横道右键菜单
      如果内容高度小于点击与底部的差值则向上
    */
    // 格式化右键菜单配置
    formatMenus(item, menuArr) {
      const _menus = [];
      if (menuArr instanceof Array && menuArr.length > 0) {
        const _self = this;
        for (let index = 0; index < menuArr.length; index++) {
          const element = menuArr[index];
          element.label = element.cbName;
          if (element.children instanceof Array && element.children.length > 0) {
            this.formatMenus(item, element.children);
          } else {
            element.onClick = () => {
              _self.$store._invoke(element.cbNumber, item);
            };
            delete element.children;
          }
          _menus.push(element);
        }
      }
      return _menus;
    },
    ContextmenuHandle(e, item) {
      const _self = this;
      const _menus = item.menus;
      _menus instanceof Array &&
      _menus.length > 0 &&
      (() => {
        const items = _self.formatMenus(item, _menus);
        if (items.length > 0) {
          _self.$contextmenu({
            items,
            event,
            customClass: "bar-custom-class-hfx",
            zIndex: 5000,
            minWidth: 110,
          });
        }
      })();
    },
    /* 横道拖拽 */
    Dragstart(obj, e) {
      const _dragS = this.getPos(e);
      _dragS.dragItem = obj;
      _dragS.ganttType = this.ganttType;
      const sInfo = JSON.stringify(_dragS);
      e.dataTransfer.setData("dragInfo", sInfo);
      this.$store.commit("set_isDragging", true);
      if (this.$store.state.viewSchem.isDropYAxisShow) {
        window.sessionStorage.dragInfo_common_gantt = sInfo; // 通过全局存储,移动过程做效果无法携带e信息
      }
    },
    // 移动过程处理 指示线
    DragMove(e) {
      if (this.$store.state.viewSchem.isDropYAxisShow) {
        try {
          if (
            this.$store.state.viewSchem.dropTargetType !== 1 &&
            window.sessionStorage.dragInfo_common_gantt
          ) {
            return false;
          }
          const _dragInfo = JSON.parse(window.sessionStorage.dragInfo_common_gantt);
          const { x, dragItem } = _dragInfo;
          const _dragE = this.getPos(e);
          const _diffX = _dragE.x - x; // 移动的横向距离
          const _diffLCB = dragItem.crossObjName == "landmarks" ? 10 : 0; // 里程碑中心偏移量
          const _diffPosLeft = dragItem._left + _diffX + _diffLCB; // 最新图中位置待转换成时间戳
          const _summaryHeight = (this.$store.state.summaryShow ? (this.$store.state[this.CONSTNAME.SUMMARY + "_rowsNum"] * this.$store.state.summaryCellHeight) : 0) + 1;
          const _height = `calc(100% - ${_summaryHeight}px)`;
          const guideYAxis = {
            isShow: true,
            key: "guideYAxis-" + dragItem.taskId,
            "left": _diffPosLeft + "px",
            "height": _height,
            "zIndex": 10000,
            "color": "#FF0000",
            "type": "solid",
            "width": 1,
          };
          this.$store.commit("set_guideYAxis", guideYAxis);
        } catch (error) {
          // console.log("不支持的数据拖动", error);
          return false;
        }
      }
    },
    DragEnd(e) {
      this.$store.commit("set_isDragging", false);
      if (this.$store.state.viewSchem.isDropYAxisShow) {
        this.$store.commit("set_guideYAxis", null);
        window.sessionStorage.removeItem("dragInfo_common_gantt");
      }
    },
    // 普通横道内释放
    DropHandle(e, item) {
      this.$store.commit("set_isDragging", false);
      if (e.dataTransfer.getData("dragInfo") === "") {
        console.log("不支持的数据拖动");
        return false;
      }
      const _dragInfo = JSON.parse(e.dataTransfer.getData("dragInfo"));
      const { dragItem } = _dragInfo;
      // console.log("拖拽投放_1: ", item, dragItem, e.clientX, e.clientY, _dragInfo);
      const _obj = {
        dragItem,
        dropItem: item,
      };
      this.$store.dispatch("_dropInSide", _obj);
    },
    /* 修改起始点 */
    ChangeSFTime(e, task, type = "startDate") {
      const _self = this;
      _self.getAuthentication &&
      (() => {
        const _type = _self.$store.state.cellUnitType;
        const index = task.taskListIndex;

        const clickTimes = Date.now();
        const _startPoint = _self.getPos(e);
        const _oldTimes = task[type];
        const _target = this.$utils.deepClone(this.barsArr[task._selfIndex]);
        const _baseWidth = this.$store.getters.cellWidth;
        let diffWidth = 0;
        const odivParent = e.currentTarget.parentNode; // 调整容器
        const showLineIndex = type === "startDate" ? 0 : 1;
        const showLineNode = odivParent.getElementsByClassName("task-adjust-line")[showLineIndex];

        const _uuid = _self.$store.state.uuid;
        let isEarliest = false;
        let isMoving = false;
        this.adjustType = type; //  操作提示·时间类型

        document.getElementById(_uuid).onmousemove = _self.$utils.throttle((e) => {
          const _endPoint = _self.getPos(e);
          const diffx = _endPoint.x - _startPoint.x;
          const min = _self.minAdjustableWidth;
          const ratio = type === "startDate" ? -1 : 1;
          let _newWidth = task._width + diffx * ratio <= min ? min : (task._width + diffx * ratio);
          if (type === "startDate") {
            let _newLeft = 0;
            if (task._left - (_baseWidth * 2) <= (diffx * ratio)) {
              isEarliest = true;
              _newLeft = (task._left - (_baseWidth * 2)) * ratio;
              _newWidth = task._width + (task._left - (_baseWidth * 2));
              diffWidth = _newWidth - task._width;
            } else {
              isEarliest = false;
              _newLeft = _newWidth <= min ? (task._width - min) : diffx;
              diffWidth = _newLeft;
            }
            odivParent.style.left = _newLeft + "px";
          } else {
            diffWidth = _newWidth - task._width;
          }
          _self.isAdjust = true;
          odivParent.style.width = _newWidth + "px";
          odivParent.style.zIndex = 1500 + task.curRow;
          showLineNode.style.background = "#999ca3";
          if (diffWidth === 0) {
            isMoving = false;
          } else {
            isMoving = true;
          }
          if (isEarliest) {
            task[type] = _self.$dayjs(_self.$store.state.viewSchem.start).startOf(_type).valueOf();
          } else if (type === "startDate" || type === "endDate") {
            const diffTimes = this.$utils.getDiffTimes(_self.$store.state.cellUnitType, diffWidth, _baseWidth);
            task[type] = _oldTimes + diffTimes;
          }
          _self.adjustInfo = task; // 操作提示·时间值
          /* 提示内容 */
          let _percentShow = "";
          if (
            task.showPercent &&
            task.planDateTimeStamp !== 0 &&
            type === "endDate"
          ) {
            _percentShow = ((task["endDate"] - task["startDate"]) / task.planDateTimeStamp * 100).toFixed(2) + "%";
          }
          _self.adjustInfo._percentShow = _percentShow;
        }, 20, false);

        document.getElementById(_uuid).onmouseup = (e) => {
          document.getElementById(_uuid).onmousemove = null;
          document.getElementById(_uuid).onmouseup = null;
          if (
            isMoving &&
            (Date.now() - clickTimes > 250)
          ) {
            isMoving = false;
            _target[type] = task[type];
            _target.adjustType = type;
            _self.$store.dispatch("_adjustTask", {
              item: _target,
              index: index,
              targetGanttType: this.ganttType,
            });
          } else {
            console.log("未有效移动");
          }
          // 重置
          _self.adjustType = "default";
          _self.adjustInfo = {};
          odivParent.style.left = "";
          odivParent.style.width = "";
          odivParent.style.zIndex = "";
          showLineNode.style.background = "";
          _self.isAdjust = false;
        };
        e.stopPropagation();
        e.preventDefault();
        return false;
      })();
    },

    // 设置高亮
    SetHighlight(item) {
      if (
        item.highlightType != null &&
        item.highlightType != this.CONSTNAME.DEFAULT_HIGHLIGHT_TYPE
      ) {
        this.$store.commit("set_highlightType", { ganttType: item.ganttType, type: item.highlightType });
      } else {
        this.$store.commit("set_highlightType", { ganttType: this.ganttType });
      }
    },
    SetInintlight() {
      this.$store.commit("set_highlightType", { ganttType: this.ganttType });
    },
    // 设置全横道范围·虚横道
    ShowDashedBar(item) {
      const _self = this;
      if (item.isDashedBar === true) {
        const _taskHeight = item.crossObjName == "task" ? (item.crossHeightVal || _self.$store.state.taskHeight) : _self.$store.state.taskHeight;

        const _baseWidth = _self.$store.getters.cellWidth;
        const _type = _self.$store.state.cellUnitType;
        const _left = _self.$utils.getDiffWidth(_type, _self.$store.getters.totalStartAndEnd.start, item.dashedStartDate, _baseWidth);
        const _width = _self.$utils.getDiffWidth(_type, item.dashedStartDate, item.dashedEndDate, _baseWidth);

        const dashedBar = {
          "show": item.isDashedBar,
          "css": {
            "left": _left - 2 + "px",
            "top": item._top - 2 + "px",
            "width": _width + 4 + "px",
            "height": _taskHeight + 4 + "px",
            "border-color": _self.$store.state.theme,
          },
        };
        this.$store.commit("set_dashedBar", {
          ganttType: this.ganttType,
          dashedBar,
        });
      } else {
        _self.SetInintDashedBar();
      }

    },
    SetInintDashedBar() {
      this.$store.commit("set_dashedBar", { ganttType: this.ganttType });
    },
    /* 单击·具体业务 */
    handlerClickBarSource(item) {
      const _self = this;
      /**
        选中横道联动行选中:
        规则:仅计划区pageData适用,受全局参数isBarSelectRow控制,忽略汇总巴条;
        1:选中横道同步切换左侧表格选中集合为仅选中当前行
      */
      const isBarSelectRow = _self.$store.state.viewSchem.isBarSelectRow;
      const ganttType = item.ganttType;
      if (
        isBarSelectRow &&
        ganttType != CONSTNAME.TODOS &&
        item.crossObjName != "group"
      ) {
        const id = item.groupId;
        _self.$store.commit("set_selectStatus_area", {
          ganttType,
          selectedArr: [id],
        });
      }
      _self.$store.dispatch("_selectTask", item);
      _self.getAuthentication &&
      (() => {
        if (
          _self.dashStartTask &&
          _self.dashStartTask.taskId &&
          _self.dashStartTask.taskId === item.taskId
        ) {
          _self.ResetDashLines();
        } else {
          _self.LockStart(item);
          _self.ShowTaskLink(item._parentIndex);
          _self.SetHighlight(item);
          _self.ShowDashedBar(item);

        }
      })();
    },

    // 单机
    handlerClickBar(item) {
      if (item.dblclickBarStatus) {
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          this.handlerClickBarSource(item);
        }, 300);
      } else {
        this.handlerClickBarSource(item);
      }
    },
    // 双击
    handlerDBClickBar(item) {
      clearTimeout(this.time);
      if (
        this.getAuthentication &&
        item.dblclickBarStatus
      ) {
        this.$store.dispatch("_dblclickBar", item);
      }

    },
  },

};
</script>
<style scoped lang='less'>
@import './Content.less';
</style>
